import Application from "../../Application";
import { IIndexTypeGroupService } from "../service/IndexGroupService";

export default class AssignGroupChildrenGroupsInteractor {
  private application: Application;
  private indexTypeGroupService: IIndexTypeGroupService;

  constructor({ application, indexTypeGroupService }: any) {
    this.application = application;
    this.indexTypeGroupService = indexTypeGroupService;
  }

  async execute(groupId: number, childrenGroupIds: number[]) {
    return this.indexTypeGroupService.addChildGroupsToIndexTypeGroup(
      groupId,
      childrenGroupIds
    );
  }
}
